<template>
  <div id="RequestLetterSodorEsterdad" class="bnp-se" dir="rtl">
    <loading v-if="loadingRender"></loading>
    <panel
      Title="درخواست استرداد سپرده"
      Des="از طریق این فرم می‌توانید درخواست استرداد تمام یا بخشی از سپرده خود را برای مدیر سامانه ارسال کنید."
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <net-pa-tab
          :Tabs="RequestTabs"
          :Active="activeTab"
          @change="onTabChange"
        ></net-pa-tab>
        <div class="tab-content">
          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'nav-se-form' }"
            id="nav-se-form"
            role="tabpanel"
            aria-labelledby="nav-se-form-tab"
          >
            <net-pa-card :Compact="true">
              <template slot="content">
                <!-- درخواست در حال بررسی -->
                <div
                  v-if="HasPendingRequest"
                  class="bnp-se-pending"
                  role="status"
                >
                  <i
                    class="fas fa-hourglass-half bnp-se-pending__icon"
                    aria-hidden="true"
                  ></i>
                  <div class="bnp-se-pending__body">
                    <div class="bnp-se-pending__title">
                      درخواست شما در حال بررسی است
                      <span class="bnp-se-badge bnp-se-badge--warning"
                        >در حال بررسی</span
                      >
                    </div>
                    <p class="bnp-se-pending__text">
                      عضو محترم، درخواست استرداد سپرده شما در تاریخ
                      <b dir="ltr">{{ zamanInsert }}</b> ارسال شده است. تا زمان
                      تعیین وضعیت توسط مدیر سامانه، امکان ارسال درخواست جدید
                      وجود ندارد.
                    </p>
                  </div>
                </div>

                <!-- فرم نامه -->
                <div v-else class="bnp-se-form">
                  <header class="bnp-se-letter-head">
                    <span class="bnp-se-eyebrow">{{
                      $store.state.NameSandogh
                    }}</span>
                    <h5 class="bnp-se-letter-title">
                      فرم درخواست استرداد سپرده
                    </h5>
                  </header>

                  <div class="bnp-se-salutation">
                    <p class="bnp-se-salutation__to">
                      مدیرعامل محترم شرکت تعاونی اعتبار
                    </p>
                    <p>با سلام</p>
                    <p>
                      احتراماً، خواهشمند است دستور فرمایید نسبت به استرداد سپرده
                      اینجانب مطابق مشخصات زیر اقدام گردد.
                    </p>
                  </div>

                  <dl class="bnp-se-tiles">
                    <div class="bnp-se-tile">
                      <dt>درخواست‌کننده</dt>
                      <dd>{{ NamFam || "—" }}</dd>
                    </div>
                    <div class="bnp-se-tile">
                      <dt>کد ملی</dt>
                      <dd dir="ltr" class="bnp-se-ltr">
                        {{ CodeMeli || "—" }}
                      </dd>
                    </div>
                  </dl>

                  <!-- مشخصات استرداد -->
                  <section class="bnp-se-block">
                    <div class="bnp-se-section-title">
                      <i class="fas fa-hand-holding-usd" aria-hidden="true"></i>
                      مشخصات استرداد
                    </div>
                    <p class="bnp-se-desc">
                      اینجانب <b>{{ NamFam }}</b> با کد ملی
                      <b dir="ltr">{{ CodeMeli }}</b> با توجه به سپرده‌گذاری
                      خویش به مبلغ
                      <b>{{ Mablagh ? $Comma3ragham(Mablagh) : "..." }}</b>
                      ریال، درخواست استرداد مبلغ
                      <b>{{
                        MablaghSeporde ? $Comma3ragham(MablaghSeporde) : "..."
                      }}</b>
                      ریال به شماره حساب
                      <b dir="ltr">{{ ShomareHesab || "..." }}</b>
                      {{ BnakName }} را دارم.
                    </p>
                    <div class="bnp-se-grid">
                      <div class="bnp-se-field">
                        <label for="seMablagh" class="bnp-se-label"
                          >مبلغ سپرده‌گذاری</label
                        >
                        <div class="bnp-se-unit-wrap">
                          <input
                            id="seMablagh"
                            v-model="Mablagh"
                            type="text"
                            dir="ltr"
                            inputmode="numeric"
                            autocomplete="off"
                            placeholder="0"
                            class="form-control bnp-se-control bnp-se-control--unit 3ragham"
                            @keypress="$ValidNumber($event, 11)"
                          />
                          <span class="bnp-se-unit">ریال</span>
                        </div>
                      </div>
                      <div class="bnp-se-field">
                        <label for="seMablaghSeporde" class="bnp-se-label"
                          >مبلغ درخواستی برای استرداد</label
                        >
                        <div class="bnp-se-unit-wrap">
                          <input
                            id="seMablaghSeporde"
                            v-model="MablaghSeporde"
                            type="text"
                            dir="ltr"
                            inputmode="numeric"
                            autocomplete="off"
                            placeholder="0"
                            class="form-control bnp-se-control bnp-se-control--unit 3ragham"
                            @keypress="$ValidNumber($event, 11)"
                          />
                          <span class="bnp-se-unit">ریال</span>
                        </div>
                      </div>
                      <div class="bnp-se-field">
                        <label for="seShomareHesab" class="bnp-se-label"
                          >شماره حساب مقصد</label
                        >
                        <div class="bnp-se-unit-wrap">
                          <input
                            id="seShomareHesab"
                            v-model="ShomareHesab"
                            :disabled="isDisabled"
                            type="text"
                            dir="ltr"
                            inputmode="numeric"
                            autocomplete="off"
                            placeholder="شماره حساب"
                            class="form-control bnp-se-control"
                          />
                          <i
                            v-if="isDisabled"
                            class="fas fa-lock bnp-se-lock"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <small v-if="BnakName" class="bnp-se-help">
                          <i class="fas fa-university" aria-hidden="true"></i>
                          {{ BnakName
                          }}<span v-if="isDisabled"> — حساب ثبت‌شده شما</span>
                        </small>
                      </div>
                    </div>
                  </section>

                  <!-- امتیاز وام -->
                  <section class="bnp-se-points">
                    <div class="bnp-se-section-title">
                      <i class="fas fa-star" aria-hidden="true"></i>
                      امتیاز وام
                    </div>
                    <p class="bnp-se-points__hint">
                      یکی از گزینه‌های زیر را برای امتیاز وام خود انتخاب کنید.
                    </p>
                    <div
                      class="bnp-se-options"
                      role="radiogroup"
                      aria-label="امتیاز وام"
                    >
                      <div
                        v-for="opt in EmtiazOptions"
                        :key="opt.value"
                        class="bnp-se-option"
                        :class="{
                          'bnp-se-option--active': IsSaveEmtiaz == opt.value,
                        }"
                      >
                        <label
                          :for="'seEmtiaz' + opt.value"
                          class="bnp-se-option__main"
                        >
                          <input
                            :id="'seEmtiaz' + opt.value"
                            type="radio"
                            name="seEmtiaz"
                            class="bnp-se-option__input"
                            :value="opt.value"
                            v-model="IsSaveEmtiaz"
                          />
                          <span class="bnp-se-option__icon" aria-hidden="true"
                            ><i :class="opt.icon"></i
                          ></span>
                          <span class="bnp-se-option__text">
                            <span class="bnp-se-option__title">{{
                              opt.title
                            }}</span>
                            <span class="bnp-se-option__desc">{{
                              opt.desc
                            }}</span>
                          </span>
                          <span class="bnp-se-option__check" aria-hidden="true"
                            ><i class="fas fa-check"></i
                          ></span>
                        </label>

                        <transition name="bnp-se-reveal">
                          <div
                            v-if="opt.value == 2 && IsSaveEmtiaz == 2"
                            class="bnp-se-option__extra bnp-se-date"
                          >
                            <span class="bnp-se-label"
                              >محاسبه امتیاز تا تاریخ</span
                            >
                            <date-picker
                              :editable="false"
                              :auto-submit="true"
                              color="#287db4"
                              placeholder="انتخاب تاریخ"
                              v-model="TarixEmatiazVam"
                            ></date-picker>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </section>

                  <div class="bnp-se-footer">
                    <button
                      type="button"
                      class="bnp-se-btn bnp-se-btn--primary"
                      :disabled="IsSending || !HasSeporde"
                      @click="question()"
                    >
                      <i class="fas fa-paper-plane" aria-hidden="true"></i>
                      {{ IsSending ? "در حال ارسال..." : "ثبت درخواست" }}
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>

          <div
            class="tab-pane fade"
            :class="{ 'show active': activeTab === 'nav-se-history' }"
            id="nav-se-history"
            role="tabpanel"
            aria-labelledby="nav-se-history-tab"
          >
            <net-pa-card :Compact="true">
              <template slot="content">
                <div v-if="ListRequest.length == 0" class="bnp-se-empty">
                  <i class="fas fa-inbox" aria-hidden="true"></i>
                  تاکنون درخواستی ثبت نکرده‌اید.
                </div>

                <ul v-else class="bnp-se-history">
                  <li
                    v-for="(item, index) in HistoryList"
                    :key="index"
                    class="bnp-se-history__item"
                  >
                    <div class="bnp-se-history__head">
                      <span class="bnp-se-history__date">
                        <i class="far fa-calendar-alt" aria-hidden="true"></i>
                        <span dir="ltr">{{ item.zamanInsert }}</span>
                      </span>
                      <span
                        class="bnp-se-badge"
                        :class="'bnp-se-badge--' + StatusOf(item).tone"
                      >
                        <i :class="StatusOf(item).icon" aria-hidden="true"></i>
                        {{ StatusOf(item).text }}
                      </span>
                    </div>
                    <dl class="bnp-se-history__grid">
                      <div>
                        <dt>شماره حساب</dt>
                        <dd dir="ltr" class="bnp-se-ltr">
                          {{ item.shomareHesab || "—" }}
                        </dd>
                      </div>
                      <div>
                        <dt>مبلغ درخواستی</dt>
                        <dd>
                          {{
                            item.mablaghSeporde == null
                              ? "—"
                              : $Comma3ragham(item.mablaghSeporde) + " ریال"
                          }}
                        </dd>
                      </div>
                    </dl>
                  </li>
                </ul>
              </template>
            </net-pa-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaTab from "../Tools/NetPa/NetPaTab.vue";
import loading from "../Tools/NetPa/Loading.vue";
export default {
  components: { NetPaCard, Panel, NetPaTab, loading },
  data() {
    return {
      HasSeporde: false,
      loadingRender: false,
      NamFam: "",
      CodeMeli: "",
      ShomareHesab: null,
      MablaghSeporde: "",
      Mablagh: "",
      TarixEmatiazVam: "",
      DataAxios: {
        ArryfildValue: {},
        Method: "Post",
        Action: "Letter/PostSodorEsterdad",
        Token: this.$session.get("TokenNetPa"),
      },
      IsEnsraf: false,
      IsSending: false,
      zamanInsert: "",
      BnakName: "",
      isDisabled: false,
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosGetNoeId: {
        Method: "Post",
        Action: "ListTaahodat/GetTblNoe",
      },
      IsSaveEmtiaz: 1,
      ListRequest: [],
      activeTab: "nav-se-form",
    };
  },
  computed: {
    RequestTabs() {
      return [
        { id: "nav-se-form", title: "ثبت درخواست" },
        {
          id: "nav-se-history",
          title: this.ListRequest.length
            ? "سوابق درخواست (" + this.ListRequest.length + ")"
            : "سوابق درخواست",
        },
      ];
    },
    HasPendingRequest() {
      return (
        this.ListRequest.length > 0 &&
        this.ListRequest[this.ListRequest.length - 1].vaziatGrp44 == null
      );
    },
    HistoryList() {
      return this.ListRequest.slice().reverse();
    },
    EmtiazOptions() {
      return [
        {
          value: 1,
          icon: "fas fa-bookmark",
          title: "ذخیره امتیاز",
          desc: "امتیاز وام اینجانب ذخیره گردد.",
        },
        /* { value: 2, icon: 'fas fa-calendar-check', title: 'محاسبه تا تاریخ مشخص', desc: 'امتیاز وام اینجانب تا تاریخ انتخابی محاسبه گردد.' },*/
      ];
    },
  },
  updated() {
    this.$PutCommatoInput();
  },
  mounted() {
    this.NamFam =
      this.$session.get("UserInfoNetPa").ozvName +
      " " +
      this.$session.get("UserInfoNetPa").ozvFamily;
    this.CodeMeli = this.$session.get("UserInfoNetPa").codeMeli.trim();
    this.TarixEmatiazVam = this.$store.state.JalaliDate;
    this.GetData();
  },
  methods: {
    onTabChange(id) {
      this.activeTab = id;
    },
    switchTab(id) {
      this.activeTab = id;
      this.$nextTick(() => {
        const link = document.getElementById(id + "-tab");
        if (link && window.$) {
          window.$(link).tab("show");
        } else if (link) {
          link.click();
        }
      });
    },
    StatusOf(item) {
      if (item.vaziatGrp44 == 7190)
        return {
          tone: "success",
          icon: "fas fa-check-circle",
          text: "تأیید شد",
        };
      if (item.vaziatGrp44 == 7191)
        return { tone: "danger", icon: "fas fa-times-circle", text: "رد شد" };
      return {
        tone: "warning",
        icon: "fas fa-hourglass-half",
        text: "در حال بررسی",
      };
    },
    question() {
      if (this.Mablagh == null || this.Mablagh == "" || this.Mablagh <= 0) {
        this.$mySweetDefault(
          "خطا",
          "لطفاً مبلغ سپرده‌گذاری را به‌درستی وارد کنید",
          "error",
          2500,
        );
        return;
      }
      if (
        this.MablaghSeporde == null ||
        this.MablaghSeporde == "" ||
        this.MablaghSeporde <= 0
      ) {
        this.$mySweetDefault(
          "خطا",
          "لطفاً مبلغ درخواستی برای استرداد را به‌درستی وارد کنید",
          "error",
          2500,
        );
        return;
      }
      if (this.ShomareHesab == null || this.ShomareHesab == "") {
        this.$mySweetDefault(
          "خطا",
          "لطفاً شماره حساب مقصد را وارد کنید",
          "error",
          2500,
        );
        return;
      }
      this.$SweetQustion(
        "اطمینان از درخواست استرداد سپرده",
        "آیا از درخواست استرداد سپرده خود به مبلغ " +
          this.$Comma3ragham(this.MablaghSeporde) +
          " ریال اطمینان دارید؟",
        "question",
        "تایید ",
        "انصراف",
        this.CodeMeli,
        this.SendData,
        this.isNotConfirmed,
      );
    },
    SendData() {
      this.DataAxios.ArryfildValue.NamFam = this.NamFam;
      this.DataAxios.ArryfildValue.CodeMeli = this.CodeMeli;
      this.DataAxios.ArryfildValue.MablaghSeporde = Number(
        this.MablaghSeporde.replaceAll(/,/g, ""),
      );
      this.DataAxios.ArryfildValue.ShomareHesab = this.ShomareHesab + "";
      this.DataAxios.ArryfildValue.TarixEmatiazVam =
        this.IsSaveEmtiaz == 1 ? null : this.TarixEmatiazVam;
      this.IsSending = true;
      this.$PostData(this.DataAxios)
        .then((result) => {
          if (result) {
            this.$mySweetDefaultTost(
              "عملیات موفق",
              "درخواست استرداد سپرده شما با موفقیت ثبت گردید",
              "success",
              4000,
            );
            this.switchTab("nav-se-history");
          }
        })
        .finally(() => {
          this.IsSending = false;
          this.GetData();
        });
    },
    isNotConfirmed() {},
    GetData() {
      this.loadingRender = true;
      var formdata = new FormData();
      formdata.append("codemeli", this.CodeMeli);
      var DataAxios_GetData = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "Letter/GetSodorEsterdad",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxios_GetData)
        .then((data) => {
          if (data.length > 0) {
            this.loadingRender = false;
            this.IsEnsraf = true;
            this.zamanInsert = data[data.length - 1].zamanInsert;
            this.ListRequest = data;
          } else this.IsEnsraf = false;
        })
        .finally(() => {
          this.GetAccount();
        });
    },
    GEtAzaHesab() {
      var formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      var DataAxios = {
        Method: "Post",
        Action: "SelAzaHesab",
        ArryfildValue: formData,
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxios)
        .then((result) => {
          if (result.length > 0) {
            this.loadingRender = false;
            var filterd = result.filter((x) => x.active == true);
            this.ShomareHesab = filterd[0].hesabNo.trim();
            this.BnakName = "بانک " + filterd[0].bankName;
            this.isDisabled = true;
          }
        })
        .finally(() => {
          this.loadingRender = false;
        });
    },
    GetAccount() {
      console.log(1);

      this.$PostFormData(this.DataAxiosGetNoeId).then((data) => {
        if (data.status != null) {
          this.$mySweetDefault("خطا", "خطایی پیش آمد.", "error", 2500);
          return;
        } else {
          var wwwtblnoe = data.filter((x) => x.bnpCashDbtblNoeId == 363480);

          if (wwwtblnoe.length > 0) {
            const formData = new FormData();
            formData.append(
              "wwwtblAzaId",
              this.$session.get("UserInfoNetPa").wwwtblAzaId,
            );
            formData.append("wwwtblSarfaslTypeId", 2);

            this.DataAxiosRow.ArryfildValue = formData;
            this.$PostFormData(this.DataAxiosRow)
              .then((data) => {
                if (data.length > 0) {
                  //console.log("/*/*/*/*/*/*//*//*//*/*/*/*/*", data);
                  this.loadingRender = false;

                  // var filter = data.filter((x) => x.wwwtblNoeId == Number(JSON.parse($GetNoeIdPishFarz()))) /// قرار شد که از سهامداران برداشته بشه  و بشه سپرده اعضا
                  var filter = data.filter(
                    (x) => x.wwwtblNoeId == wwwtblnoe[0].id && x.mande > 0,
                  );
                  // var filter = data.filter((x) => x.bnpCashDBtblNoeId == 363480)//ایدی سپرده اعضای پایین
                  if (filter.length > 0) {
                    this.HasSeporde = true;
                    this.Mablagh = filter[0].mande;
                  } else {
                    this.HasSeporde = false;
                    this.$mySweetDefault(
                      "خطا",
                      "شما سپرده‌ای ندارید.",
                      "error",
                      2500,
                    );
                    return;
                  }
                }
              })
              .finally(() => {
                this.GEtAzaHesab();
              });
          } else {
            this.loadingRender = false;
            this.HasSeporde = false;
            this.$mySweetDefault("خطا", "خطایی پیش آمد.", "error", 2500);
            return;
          }
        }
        //console.log("---------------------wwwtblnoe-------", data);
      });
    },
  },
};
</script>
<style scoped>
.bnp-se {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-brand-blue: #287db4;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-surface-subtle: #f9fbfc;
  --bnp-surface-accent: #edf7fb;
  --bnp-info-soft: #edf5fb;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-border-hover: #bdcbd4;
  --bnp-warning: #c48726;
  --bnp-warning-soft: #fff7e8;
  --bnp-danger: #b44f46;
  --bnp-danger-surface: #fcefed;
  --bnp-radius-md: 14px;
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-focus-color: #05b8c8;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-motion-fast: 180ms;

  color: var(--bnp-text-primary);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  text-align: right;
}

.bnp-se-ltr {
  unicode-bidi: plaintext;
  text-align: right;
}

/* ---------- Letter head ---------- */
.bnp-se-letter-head {
  padding-bottom: 14px;
  margin-bottom: 16px;
  text-align: center;
  border-bottom: 1px solid var(--bnp-border-subtle);
}

.bnp-se-eyebrow {
  display: block;
  margin-bottom: 4px;
  color: var(--bnp-brand-blue);
  font-size: 12px;
  font-weight: 700;
}

.bnp-se-letter-title {
  margin: 0;
  color: var(--bnp-brand-navy);
  font-size: 18px;
  font-weight: 800;
  line-height: 1.6;
}

.bnp-se-salutation {
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.9;
}

.bnp-se-salutation p {
  margin: 0;
}

.bnp-se-salutation__to {
  color: var(--bnp-brand-navy);
  font-weight: 700;
}

/* ---------- Tiles ---------- */
.bnp-se-tiles {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 0 0 20px;
}

.bnp-se-tile {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: 12px;
  background: var(--bnp-surface-subtle);
}

.bnp-se-tile dt {
  margin: 0 0 2px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.8;
}

.bnp-se-tile dd {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  word-break: break-word;
}

/* ---------- Sections ---------- */
.bnp-se-block {
  padding: 14px 16px;
  border: 1px solid rgba(5, 184, 200, 0.4);
  border-radius: var(--bnp-radius-md);
  background: linear-gradient(
    100deg,
    rgba(5, 184, 200, 0.05),
    rgba(141, 88, 164, 0.03) 60%,
    #fff
  );
}

.bnp-se-points {
  margin-top: 20px;
}

.bnp-se-section-title {
  margin-bottom: 8px;
  color: var(--bnp-brand-navy);
  font-size: 14px;
  font-weight: 800;
}

.bnp-se-section-title i {
  margin-left: 6px;
  color: var(--bnp-brand-blue);
}

.bnp-se-desc {
  margin: 0 0 14px;
  color: var(--bnp-text-secondary);
  font-size: 13px;
  line-height: 1.9;
}

.bnp-se-desc b {
  color: var(--bnp-text-primary);
  font-weight: 700;
}

/* ---------- Fields ---------- */
.bnp-se-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.bnp-se-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.bnp-se-label {
  display: block;
  margin-bottom: 6px;
  color: var(--bnp-text-primary);
  font-size: 13px;
  font-weight: 700;
}

.bnp-se-help {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  line-height: 1.8;
}

.bnp-se-help i {
  color: var(--bnp-brand-blue);
}

.bnp-se-unit-wrap {
  position: relative;
}

.bnp-se-control {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  color: var(--bnp-text-primary);
  font-family: inherit;
  font-size: 15px !important;
  font-weight: 700;
  text-align: center;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background-color: var(--bnp-surface-subtle);
  transition: border-color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-se-control--unit {
  padding: 0 52px;
}

.bnp-se-control:hover {
  border-color: var(--bnp-border-hover);
}

.bnp-se-control:focus {
  border-color: var(--bnp-focus-color);
  background-color: #fff;
  box-shadow: var(--bnp-focus-ring);
  outline: none;
}

.bnp-se-control:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background-color: var(--bnp-surface-accent);
}

.bnp-se-control::placeholder {
  color: #a3adb8;
  font-weight: 400;
}

.bnp-se-unit,
.bnp-se-lock {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 700;
  pointer-events: none;
}

/* ---------- Options ---------- */
.bnp-se-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 12px;
}

.bnp-se-points__hint {
  margin: -2px 0 12px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  line-height: 1.8;
}

.bnp-se-option {
  position: relative;
  margin: 0;
  padding: 14px 16px;
  border: 1px solid var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background: #fff;
  transition: border-color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease,
    transform var(--bnp-motion-fast) ease;
}

.bnp-se-option:hover {
  border-color: var(--bnp-border-hover);
  transform: translateY(-1px);
}

.bnp-se-option--active {
  border-color: rgba(5, 184, 200, 0.6);
  background: linear-gradient(
    100deg,
    rgba(5, 184, 200, 0.06),
    rgba(141, 88, 164, 0.04) 60%,
    #fff
  );
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.1);
}

.bnp-se-option:focus-within {
  box-shadow: var(--bnp-focus-ring);
}

.bnp-se-option__main {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 48px;
  margin: 0;
  cursor: pointer;
}

.bnp-se-option__extra {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed rgba(5, 184, 200, 0.4);
}

/* رادیو برای دسترس‌پذیری و کیبورد باقی می‌ماند ولی دیده نمی‌شود */
.bnp-se-option__input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
  pointer-events: none;
}

.bnp-se-option__icon {
  display: inline-grid;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  place-items: center;
  color: var(--bnp-brand-blue);
  font-size: 16px;
  border-radius: 13px;
  background: var(--bnp-info-soft);
  box-shadow: inset 0 0 0 1px rgba(40, 125, 180, 0.1);
  transition: color var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease;
}

.bnp-se-option--active .bnp-se-option__icon {
  color: #fff;
  background: linear-gradient(
    145deg,
    var(--bnp-brand-cyan),
    var(--bnp-brand-purple)
  );
  box-shadow: 0 6px 14px rgba(86, 80, 141, 0.22);
}

.bnp-se-option__text {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
}

.bnp-se-option__title {
  color: var(--bnp-brand-navy);
  font-size: 14px;
  font-weight: 800;
  line-height: 1.7;
}

.bnp-se-option__desc {
  color: var(--bnp-text-secondary);
  font-size: 12px;
  line-height: 1.8;
}

.bnp-se-option__check {
  display: inline-grid;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  place-items: center;
  color: transparent;
  font-size: 11px;
  border: 2px solid var(--bnp-border-default);
  border-radius: 50%;
  background: #fff;
  transition: color var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease,
    border-color var(--bnp-motion-fast) ease;
}

.bnp-se-option--active .bnp-se-option__check {
  color: #fff;
  border-color: var(--bnp-brand-indigo);
  background: var(--bnp-brand-indigo);
}

.bnp-se-reveal-enter-active,
.bnp-se-reveal-leave-active {
  transition: opacity var(--bnp-motion-fast) ease,
    transform var(--bnp-motion-fast) ease;
}

.bnp-se-reveal-enter,
.bnp-se-reveal-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

/* ---------- Date picker ---------- */
.bnp-se-date >>> .vpd-main {
  display: block;
  width: 100%;
}

.bnp-se-date >>> .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 52px;
  overflow: hidden;
  cursor: pointer;
  border: 1.5px solid rgba(40, 125, 180, 0.45);
  border-radius: var(--bnp-radius-md);
  background: #fff;
  box-shadow: 0 2px 6px rgba(41, 52, 95, 0.06);
  transition: border-color var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-se-date >>> .vpd-input-group:hover {
  border-color: var(--bnp-brand-blue);
  box-shadow: 0 4px 12px rgba(40, 125, 180, 0.14);
}

.bnp-se-date >>> .vpd-input-group:focus-within {
  border-color: var(--bnp-focus-color);
  background: #fff;
  box-shadow: var(--bnp-focus-ring);
}

.bnp-se-date >>> .vpd-input-group input,
.bnp-se-date >>> .vpd-input-group input.form-control {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 49px;
  margin: 0;
  padding: 0 12px;
  color: var(--bnp-brand-navy);
  font-family: inherit;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-align: center;
  direction: ltr;
  cursor: pointer;
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.bnp-se-date >>> .vpd-input-group input::placeholder {
  color: #8a96a3;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: normal;
  direction: rtl;
}

.bnp-se-date >>> .vpd-input-group input:focus {
  outline: none;
}

.bnp-se-date >>> .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  min-width: 52px;
  margin: 0 !important;
  padding: 0 14px !important;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  border: none;
  background: linear-gradient(
    145deg,
    var(--bnp-brand-blue),
    var(--bnp-brand-indigo)
  );
}

/* ---------- Footer / button ---------- */
.bnp-se-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--bnp-border-subtle);
}

.bnp-se-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 200px;
  min-height: 52px;
  padding: 10px 22px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  border: 0;
  border-radius: var(--bnp-radius-md);
  outline: none;
  cursor: pointer;
  transition: transform var(--bnp-motion-fast) ease,
    box-shadow var(--bnp-motion-fast) ease;
}

.bnp-se-btn--primary {
  color: #fff;
  background: linear-gradient(
    110deg,
    var(--bnp-brand-navy),
    var(--bnp-brand-indigo) 58%,
    var(--bnp-brand-purple)
  );
  box-shadow: var(--bnp-shadow-md);
}

.bnp-se-btn--primary:hover:not(:disabled) {
  color: #fff;
  transform: translateY(-2px);
}

.bnp-se-btn:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

.bnp-se-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

/* ---------- Pending notice ---------- */
.bnp-se-pending {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 18px;
  border: 1px solid rgba(196, 135, 38, 0.3);
  border-radius: var(--bnp-radius-md);
  background: var(--bnp-warning-soft);
}

.bnp-se-pending__icon {
  display: inline-grid;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  place-items: center;
  color: var(--bnp-warning);
  font-size: 16px;
  border-radius: 12px;
  background: #fff;
  box-shadow: inset 0 0 0 1px rgba(196, 135, 38, 0.2);
}

.bnp-se-pending__body {
  min-width: 0;
}

.bnp-se-pending__title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  color: #6f4a0e;
  font-size: 14px;
  font-weight: 800;
}

.bnp-se-pending__text {
  margin: 0;
  color: var(--bnp-text-primary);
  font-size: 13px;
  line-height: 1.9;
}

/* ---------- Badge ---------- */
.bnp-se-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.6;
  border-radius: 999px;
}

.bnp-se-badge--success {
  color: #047a6c;
  background: rgba(5, 168, 149, 0.12);
}

.bnp-se-badge--warning {
  color: #8a5d12;
  background: #fdebc8;
}

.bnp-se-badge--danger {
  color: var(--bnp-danger);
  background: var(--bnp-danger-surface);
}

/* ---------- History ---------- */
.bnp-se-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 12px;
  color: var(--bnp-text-secondary);
  font-size: 13px;
  border: 1px dashed var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background: var(--bnp-surface-subtle);
}

.bnp-se-history {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 420px;
  margin: 0;
  padding: 0 0 0 4px;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
}

.bnp-se-history__item {
  padding: 12px 14px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: 12px;
  background: var(--bnp-surface-subtle);
}

.bnp-se-history__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--bnp-border-subtle);
}

.bnp-se-history__date {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--bnp-brand-navy);
  font-size: 13px;
  font-weight: 700;
}

.bnp-se-history__date i {
  color: var(--bnp-brand-blue);
}

.bnp-se-history__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 12px;
  margin: 0;
}

.bnp-se-history__grid dt {
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.8;
}

.bnp-se-history__grid dd {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
}

/* ---------- Responsive ---------- */
@media (max-width: 991px) {
  .bnp-se-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bnp-se-history__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .bnp-se-options {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 575px) {
  .bnp-se-tiles,
  .bnp-se-grid,
  .bnp-se-history__grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .bnp-se-btn {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .bnp-se-option,
  .bnp-se-option__icon,
  .bnp-se-option__check,
  .bnp-se-reveal-enter-active,
  .bnp-se-reveal-leave-active,
  .bnp-se-control,
  .bnp-se-btn {
    transition: none;
  }

  .bnp-se-option:hover {
    transform: none;
  }

  .bnp-se-btn--primary:hover:not(:disabled) {
    transform: none;
  }
}
</style>
